import { ReactNode, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { IconButton, SvgIconProps, SxProps, Theme, Typography, TypographyProps, TypographyPropsVariantOverrides } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Variant } from "@testing-library/react";


interface ImageTooltipInputProps {
    children?: ReactNode;
    label?: string;
    sx?: SxProps<Theme>;
    labelStyle?: SxProps<Theme>;
    labelVariant?: TypographyProps['variant'];
    iconSize?: SvgIconProps['fontSize'];

}

const InfoToolTip = ({ children, label, sx, iconSize, labelVariant = "h6", labelStyle = { paddingLeft: 2, paddingBlock: 1 } }: ImageTooltipInputProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Typography
            sx={labelStyle}
            variant={labelVariant}
            gutterBottom
        >
            {label}
            <Tooltip
                title={children}
                sx={sx}
                open={isOpen}
                onClick={() => setIsOpen(old => !old)}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
            >
                <IconButton>
                    <InfoIcon sx={{ fontSize: iconSize }} />
                </IconButton>
            </Tooltip>
        </Typography>
    );
};

export default InfoToolTip;
